import * as Sentry from '@sentry/react';

export default class RTKQueryError extends Error {
  /**
   *
   * @param {object} result The response returned from an RTKQuery fetchBaseQuery. See type FetchBaseQueryResult at FetchBaseQueryResult https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery#signature
   * @param {string|object} args The arguments provided to the query. See FetchBaseQueryArgs https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery#signature
   * @param {*} rtk The RTK Query api object containing the dispatcher, getState and more. See interface BaseQueryApi https://redux-toolkit.js.org/rtk-query/api/createApi#basequery-function-signature
   */
  constructor(result, args, endpoint, type = 'request') {
    const { error, meta } = result;
    const { status, data } = error;

    super(`${endpoint} ${type} failed with status ${status}`);
    this.name = 'RTKQueryError';
    this.status = status;
    this.data = data;
    this.args = args;
    this.meta = meta;
    this.endpoint = endpoint;
    this.type = type;
  }

  get request() {
    return this.meta?.request;
  }

  get url() {
    return this.request?.url;
  }

  get fingerprint() {
    return [this.name, this.endpoint, this.status];
  }

  report(cb) {
    Sentry.captureException(this, (scope) => {
      scope.setFingerprint(this.fingerprint);

      if (this.data?.error) scope.setExtra('error', this.data.error);
      if (this.args) scope.setExtra('args', this.args);

      if (typeof cb === 'function') cb(scope);
    });
  }
}
